import { userAtom } from '@/global-store';
import RouterLink from '@components/RouterLink';
import { Heart } from 'lucide-react';
import { useAtom } from 'jotai';
import { cn } from '@helpers/cn';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

interface FooterProps {
  isColumns?: boolean;
}

const Footer = ({ isColumns }: FooterProps) => {
  const { t } = useInlineTranslation();
  const [user] = useAtom(userAtom);

  const links = [
    ...(user
      ? [
          {
            href: '/page-overview',
            name: t('pageOverview'),
            external: false,
          },
        ]
      : []),
    {
      href: 'https://status.eye-able.com',
      name: t('status'),
      description: t('uptime'),
    },
    {
      href: 'EAmission',
      name: t('footerUs'),
    },
    { href: 'EAblog', name: t('footerBlog') },
    { href: '/privacy-policy', name: t('footerDataPrivacy'), external: !user },
  ];

  return (
    <footer
      id='dashboard-footer'
      tabIndex={-1}
      role='contentinfo'
      className={cn(
        'eye:flex eye:items-center eye:justify-between eye:mt-auto eye:w-full eye:gap-3xs eye:text-14 eye:pt-m eye:outline-none',
        isColumns ? 'eye:flex-col' : 'eye:flex-col eye:xl:flex-row',
      )}
    >
      <div>
        &copy; {new Date().getFullYear()}, made with
        <Heart
          aria-label={t('love')}
          fill='black'
          strokeWidth={0}
          className='eye:inline eye:h-[14px] eye:w-[14px] eye:mx-5xs eye:-mt-4'
        />
        by{' '}
        <RouterLink color='inherit' fontWeight='500' to='https://eye-able.com'>
          Web Inclusion GmbH
        </RouterLink>{' '}
        for a better web.
      </div>
      <nav aria-label={t('footerNavigation')}>
        <ul className='eye:flex eye:flex-wrap eye:gap-2xs'>
          {links.map((link) => (
            <li key={link.href}>
              <RouterLink
                title={link.description}
                to={link.href}
                color='inherit'
                external={link.external ?? true}
              >
                {link.name}
              </RouterLink>
            </li>
          ))}
        </ul>
      </nav>
    </footer>
  );
};

export default Footer;
